import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

const prefix = "far";
const iconName = "circle-notch";
const width = 512;
const height = 512;
const aliases: string[] = [];
const unicode = "f1ce";
const svgPathData =
    "M215.1 26.33C218.7 39.07 211.4 52.36 198.6 56.01C111.6 80.92 48 161.1 48 255.1C48 370.9 141.1 463.1 256 463.1C370.9 463.1 464 370.9 464 255.1C464 161.1 400.4 80.92 313.4 56.01C300.6 52.36 293.3 39.07 296.9 26.33C300.6 13.59 313.9 6.214 326.6 9.863C433.6 40.51 512 139.1 512 255.1C512 397.4 397.4 511.1 256 511.1C114.6 511.1 0 397.4 0 255.1C0 139.1 78.37 40.51 185.4 9.863C198.1 6.214 211.4 13.59 215.1 26.33H215.1z";

const faCircleNotch: IconDefinition = {
    prefix: prefix,
    iconName: iconName,
    icon: [width, height, aliases, unicode, svgPathData],
};

export default faCircleNotch;
